import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IGetVenueCategoriesResponseBody, IGetVenueCategoriesResponseData } from './types';

export const getVenueCategories = async (): Promise<IGetVenueCategoriesResponseData> => {
  const response = await fetch(`${API_URL}/venues/categories`, {});
  if (!response.ok) {
    throw new Error('Failed to fetch venue categories');
  }
  const json: IGetVenueCategoriesResponseBody = await response.json();
  return json.data;
};
